const drawer = () => {
  const openButton = document.getElementById('js-drawer-button');
  const elemMenu = document.getElementById('js-gnav');
  const mask = document.getElementById('js-drawer-mask');
  const body = document.body;
  let menuFlg = false;
  let timeoutId: NodeJS.Timeout;

  if (openButton !== null && elemMenu !== null && mask !== null) {
    openButton.addEventListener('click', function () {
      let scrollY: number;
      clearTimeout(timeoutId);

      if (menuFlg == false) {
        menuFlg = true;

        const browser = window.navigator.userAgent.toLowerCase();
        if ('scrollingElement' in document) {
          scrollY = document.scrollingElement!.scrollTop;
        } else if (browser.indexOf('webkit') > 0) {
          scrollY = parseInt(document.body.style.top || '0');
        } else {
          scrollY = parseInt(document.body.style.top || '0');
        }
        body.dataset.position = `${scrollY * -1}`;

        elemMenu.classList.remove('is-invisible');
        openButton.classList.add('is-open');

        elemMenu.classList.remove('is-close');
        elemMenu.classList.add('is-open');
        mask.classList.remove('is-mask--close');
        mask.classList.add('is-mask--open');
        body.style.top = `${scrollY * -1}px`;

        body.classList.add('is-fixed');
      } else {
        menuFlg = false;
        const positionY = Number(body.dataset.position);

        openButton.classList.remove('is-open');
        elemMenu.classList.remove('is-open');
        elemMenu.classList.add('is-close');

        mask.classList.remove('is-mask--open');
        mask.classList.add('is-mask--close');
        body.style.top = '';
        body.classList.remove('is-fixed');
        window.scrollTo(0, positionY * -1);
        body.dataset.position = '0';

        timeoutId = setTimeout(function () {
          elemMenu.classList.add('is-invisible');
        }, 500);
      }
    });

    mask.addEventListener('click', function () {
      const positionY = Number(body.dataset.position);

      clearTimeout(timeoutId);

      if (menuFlg == false) {
        return false;
      } else {
        menuFlg = false;

        openButton.classList.remove('is-open');
        elemMenu.classList.remove('is-open');
        elemMenu.classList.add('is-close');

        mask.classList.remove('is-mask--open');
        mask.classList.add('is-mask--close');
        body.style.top = '';
        body.classList.remove('is-fixed');
        window.scrollTo(0, positionY * -1);
        body.dataset.position = '0';

        timeoutId = setTimeout(function () {
          elemMenu.classList.add('is-invisible');
        }, 500);
      }
    });

    const humbergur_breakpoint = window.matchMedia('(min-width: 60.0625em)');

    humbergur_breakpoint.addListener(function () {
      if (!humbergur_breakpoint.matches) {
        return false;
      } else if (menuFlg === true) {
        //開いている場合
        menuFlg = false;
        const positionY = Number(body.dataset.position);

        openButton.classList.remove('is-open');
        elemMenu.classList.remove('is-open');
        elemMenu.classList.add('is-close');

        mask.classList.remove('is-mask--open');
        mask.classList.add('is-mask--close');
        body.style.top = '';
        body.classList.remove('is-fixed');
        window.scrollTo(0, positionY * -1);
        body.dataset.position = '0';

        timeoutId = setTimeout(function () {
          elemMenu.classList.add('is-invisible');
        }, 500);
      } else if (menuFlg === false && elemMenu.classList.contains('is-close')) {
        elemMenu.classList.remove('is-close');
      }
    });
  }
};
export { drawer };
